var globObj = {
    breakpoints: {
        xxs: 0,
        xs: 330,
        sm: 575,
        md: 767,
        lg: 1039,
        xl: 1259
    },
    container: {
        sm: 540,
        md: 720,
        lg: 1000,
        xl: 1220
    }
};

(function () {
    //Тачскрин или десктоп
    var supportsTouch = 'ontouchstart' in window || navigator.msMaxTouchPoints;
    var root = document.getElementsByTagName('html')[0];
    root.classList.add(supportsTouch ? 'touch' : 'no-touch');
})();
